import React from 'react';
import { Link } from 'react-router-dom';

export default function RefundPolicy() {
  return (
    <div className="page">
      <div className="container" style={{ maxWidth: '860px', padding: '3rem 2rem' }}>
        <div className="page-header">
          <h1>Refund &amp; Cancellation Policy</h1>
          <p>Last updated: May 27, 2026</p>
        </div>

        <div className="static-content">
          <section>
            <h2>Overview</h2>
            <p>
              This Refund &amp; Cancellation Policy is published in compliance with the Consumer
              Protection (E-Commerce) Rules, 2020. It outlines when and how you may request a refund
              for services purchased on AstroA2Z.
            </p>
          </section>

          <section>
            <h2>1. Subscription Plans</h2>

            <h3>1.1 Cooling-Off Period (Full Refund)</h3>
            <p>
              You may cancel any <strong>new subscription within 48 hours</strong> of purchase for a
              full refund, no questions asked. This applies to:
            </p>
            <ul>
              <li>First-time subscriptions</li>
              <li>Plan upgrades</li>
              <li>Annual plan purchases</li>
            </ul>

            <h3>1.2 Pro-Rata Refund (48 Hours – 7 Days)</h3>
            <p>
              If you cancel between 48 hours and 7 days from the date of purchase, you are entitled
              to a <strong>pro-rata refund</strong> for the unused portion of your subscription period,
              calculated from the date of cancellation request.
            </p>

            <h3>1.3 After 7 Days</h3>
            <p>
              Cancellations requested after 7 days from purchase will:
            </p>
            <ul>
              <li>Stop future auto-renewal billing</li>
              <li>Allow continued access until the end of the current paid period</li>
              <li><strong>Not</strong> be eligible for a refund for the current billing cycle</li>
            </ul>

            <h3>1.4 Auto-Renewal Cancellation</h3>
            <p>
              You may cancel auto-renewal at any time through Account Settings → Subscription.
              Cancelling auto-renewal does not trigger an immediate refund — it simply prevents
              the next billing cycle.
            </p>
          </section>

          <section>
            <h2>2. One-Time Purchases (Individual Readings/Reports)</h2>
            <ul>
              <li>
                <strong>Before delivery:</strong> Full refund available within 48 hours if the reading
                or report has not been generated or accessed
              </li>
              <li>
                <strong>After delivery:</strong> Once a reading or report has been generated and
                viewed/downloaded, it is considered fully delivered and is non-refundable
              </li>
              <li>
                <strong>Technical failure:</strong> If a paid reading fails to generate due to a
                technical error on our side, you will receive a full refund or a free re-generation,
                at your choice
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Priest/Puja Bookings</h2>
            <ul>
              <li>
                <strong>More than 48 hours before scheduled time:</strong> Full refund
              </li>
              <li>
                <strong>24–48 hours before:</strong> 50% refund
              </li>
              <li>
                <strong>Less than 24 hours before:</strong> Non-refundable (priest has already committed time)
              </li>
              <li>
                <strong>No-show by priest:</strong> Full refund + complimentary rescheduling
              </li>
            </ul>
          </section>

          <section>
            <h2>4. How to Request a Refund</h2>
            <ol>
              <li>Email <a href="mailto:support@astroa2z.com">support@astroa2z.com</a> with subject "Refund Request"</li>
              <li>Include your registered email, order/transaction ID, and reason for refund</li>
              <li>We will acknowledge your request within 24 hours</li>
              <li>Eligible refunds are processed within <strong>5–7 business days</strong> to the
                original payment method</li>
            </ol>
          </section>

          <section>
            <h2>5. Non-Refundable Items</h2>
            <ul>
              <li>Free trial periods (no charge was made)</li>
              <li>Readings/reports that have been fully delivered and accessed</li>
              <li>Subscription periods that have fully elapsed</li>
              <li>Gift purchases (refund goes to the purchaser, not recipient)</li>
            </ul>
          </section>

          <section>
            <h2>6. Chargebacks</h2>
            <p>
              If you file a chargeback with your bank instead of contacting us first, we reserve the
              right to suspend your account pending investigation. We encourage you to reach out to
              our support team first — we are committed to fair resolution.
            </p>
          </section>

          <section>
            <h2>7. Disputes</h2>
            <p>
              If you are dissatisfied with our refund decision, you may escalate to our{' '}
              <Link to="/grievance-officer">Grievance Officer</Link>. Unresolved disputes are subject
              to the exclusive jurisdiction of courts in Hyderabad, Telangana, India.
            </p>
          </section>

          <section>
            <h2>8. Contact</h2>
            <p>
              <strong>Refund Support:</strong>{' '}
              <a href="mailto:support@astroa2z.com">support@astroa2z.com</a><br />
              <strong>Grievance Officer:</strong>{' '}
              <a href="mailto:grievance@astroa2z.com">grievance@astroa2z.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
